import React from 'react'
import { l } from '@manychat/manyui'

import { Heading } from 'apps/aiTextImprover/components/Heading/Heading'
import { OptionsList } from 'apps/aiTextImprover/components/OptionsList/OptionsList'
import { StepLayout } from 'apps/aiTextImprover/components/StepLayout/StepLayout'
import { AiImproverGoal, Goal } from 'apps/aiTextImprover/lib/types'

interface ChooseOptionStepProps {
  options: Goal[]
  onSelect: (props: { value: AiImproverGoal; additionalValue?: string }) => void
}

export const ChooseGoalStep = ({ options, onSelect }: ChooseOptionStepProps) => (
  <StepLayout header={<Heading label={l.translate('How to improve it?')} />}>
    <p className="visually-hidden">
      {l.translate('Choose an option that you want to use to improve your text')}
    </p>

    <OptionsList options={options} onOptionSelect={onSelect} />
  </StepLayout>
)
